import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { stringify } from 'qs';
import { HttpError } from '~/components/Error/HttpError';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export type Evolution = {
  tokenType: string;
  growth: string;
  evolvedGrowth: string;
  minNftAmount: number;
  nftAmount: number;
  thumbnailUrl: string;
  contentsUrl: string;
  marketFilterIds: string;
};

export type EvolutionsResponse = {
  getReady: Evolution[];
  completed: {
    nftItemId: string;
    level: number;
    growth: string;
    contentsUrl: string;
    boost: number;
  }[];
};

export const evolutionUrl = '/api/citizen/v1/pet/evolution';

export const getEvolution = async (params?: { completedMaxSize?: number }) => {
  const { completedMaxSize = 40 } = params || {};
  const url = `${evolutionUrl}?${stringify({ completedMaxSize })}`;
  const { data } = await axios.get<EvolutionsResponse>(url);
  return data;
};

export const useEvolutions = <T = EvolutionsResponse>(
  params?: { completedMaxSize?: number },
  options?: UseDosiminQueryOptions<EvolutionsResponse, HttpError, T>
) =>
  useQuery<EvolutionsResponse, HttpError, T>({
    queryKey: ['evolution'],
    queryFn: () => getEvolution(params),
    initialData: {
      getReady: [],
      completed: [],
    },
    ...options,
  });

const initialEvolution: Evolution = {
  tokenType: '',
  growth: '',
  evolvedGrowth: '',
  minNftAmount: 0,
  nftAmount: 0,
  thumbnailUrl: '',
  contentsUrl: '',
  marketFilterIds: '',
};

export const useEvolution = (
  tokenType: Evolution['tokenType'],
  options?: UseDosiminQueryOptions<EvolutionsResponse, HttpError, Evolution>
) =>
  useEvolutions(undefined, {
    select: (data) =>
      data.getReady.find((each) => each.tokenType === tokenType) ?? initialEvolution,
    ...options,
  });
